import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    top: 10px;
    right: 15px;
`;

export const Label = styled.span`
    font-size: 1.2rem;
`;